import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { useAuthUser } from "../contexts/AuthUserContext";
import {
  getNotificationSocket,
  disconnectNotificationSocket,
} from "../utils/notifications/socket";

const NOTIFICATION_OPERATION = "MyNotifications";

export function useNotificationSocket() {
  const apollo = useApolloClient();
  const { user } = useAuthUser();

  useEffect(() => {
    const userId = user?._id || user?.id;
    const token = user?.token;

    if (!userId || !token) {
      disconnectNotificationSocket();
      return undefined;
    }

    const socket = getNotificationSocket({ token });

    const joinRoom = () => {
      socket.emit("notifications:join", { userId, token });
    };

    const handleNewNotification = () => {
      apollo
        .refetchQueries({ include: [NOTIFICATION_OPERATION] })
        .catch(() => {});
    };

    const handleError = (payload) => {
      console.warn("[notifications][socket]", payload?.error || payload);
    };

    socket.on("connect", joinRoom);
    socket.on("notifications:new", handleNewNotification);
    socket.on("notifications:error", handleError);

    if (socket.connected) {
      joinRoom();
    }

    return () => {
      socket.off("connect", joinRoom);
      socket.off("notifications:new", handleNewNotification);
      socket.off("notifications:error", handleError);
    };
  }, [apollo, user?._id, user?.id, user?.token]);
}
